<template>
  <span v-if="url_file_val">
    <img :src="url_file" style="vertical-align: middle; width: 75px; min-width: 70px" />
  </span>
  <span v-else>
    <i class="fas fa-picture-o btn-edit" title="Sem imagem"></i>
  </span>
</template>

<script>
export default {
  props: ["url_file"],
  data() {
    return {
      url_file_val: false,
    };
  },
  beforeMount() {
    this.is_img();
  },
  methods: {
    is_img() {
      var hthis = this;
      var ajax = new XMLHttpRequest();
      ajax.open("GET", hthis.url_file, true);
      ajax.send();
      ajax.onreadystatechange = function () {
        if (ajax.readyState == 4) {
          var jpg = ajax.responseText;
          if (ajax.status === 200) {
            hthis.url_file_val = true;
          } else {
            hthis.url_file_val = false;
          }
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/ImgOnOff.vue